/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface RecruitStepCriteria { 
    id?: string;
    name?: string;
    description?: string;
    recruit_step_id?: string;
    evaluation_category_id?: string;
    created_at?: Date;
    createdby?: string;
    modified_at?: Date;
    modified_by?: string;
}